import { ArchivableDataType, TableName } from "../../../../tables"
import { useEffectAfterMount } from "../../../ui"
import { cloneElement, useMemo, useRef, useState } from "react"
import { useStateHooks } from "../../../../state"

type Props = {
    table: TableName
    children: JSX.Element
}

export const ListLoaderWrapper = (props: Props) => {
    const { table, children } = props
    
    const [key, setKey] = useState(0)
    const previousLengthRef = useRef<number>()
    
    const { getList } = useStateHooks()
    const list = getList(table)
    const length = useMemo(() => list.filter(dataType => !(dataType as ArchivableDataType).archived).length, [list])

    useEffectAfterMount(() => {
        const previousLength = previousLengthRef.current
        if (previousLength !== undefined && length < previousLength) {
            setTimeout(() => setKey((prevKey) => prevKey + 1), 1000)
        }
        previousLengthRef.current = length
    }, [length])

    return cloneElement(children, { key })
}
